
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./sms.cjs.production.min.js')
} else {
  module.exports = require('./sms.cjs.development.js')
}
